import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

const CustomFrameworkListPage = lazy(() =>
  import("./pages/CustomFrameworkListPage").then((m) => ({
    default: m.CustomFrameworkListPage,
  })),
);
const CustomFrameworkBuilderPage = lazy(() =>
  import("./pages/CustomFrameworkBuilderPage").then((m) => ({
    default: m.CustomFrameworkBuilderPage,
  })),
);

const withProvider = (element) => (
  <FeatureProvider namespace={Feature_NAMESPACES.CUSTOM_FRAMEWORK}>
    {element}
  </FeatureProvider>
);

export const customFrameworkRoutes = [
  {
    path: PATHS.CUSTOM_FRAMEWORK_LIST,
    element: withProvider(<CustomFrameworkListPage />),
    handle: {
      permission: { resource: "custom_framework", action: "view" },
      companyFeatureFlag: "customFrameworkEnabled",
    },
  },
  {
    path: PATHS.CUSTOM_FRAMEWORK_BUILDER,
    element: withProvider(<CustomFrameworkBuilderPage />),
    handle: {
      permission: { resource: "custom_framework", action: "update" },
      companyFeatureFlag: "customFrameworkEnabled",
    },
  },
];
